







































import Vue from "vue";

// Import External Components
import FilterHead from "@miele/component-library-vue/src/components/modules/filter/FilterHead.vue";
import FilterHeadTag from "@miele/component-library-vue/src/components/modules/filter/FilterHeadTag.vue";
import ContainerOpener from "@miele/component-library-vue/src/components/modules/filter/ContainerOpener.vue";
import Block from "@miele/component-library-vue/src/components/content/layouts/Block.vue";

// Import Internal Components
import Search from "@/components/containers/SearchContainer.vue";

// Import Models
import { Tag } from "../../models/tag.model";

export default Vue.extend({
  name: "ResultsHeader",
  computed: {
    perfect_matches() {
      return this.$store.state.recipes.meta.perfect_matches;
    },
    tags() {
      return this.$store.state.searchParams.tags;
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  components: {
    Search,
    FilterHead,
    FilterHeadTag,
    ContainerOpener,
    Block,
  },
  methods: {
    removeTag(currentTag: Tag, event: MouseEvent): void {
      let tags: any = this.$store.state.searchParams.tags.map(
        (tag: Record<string, any>) => tag
      );
      tags = tags.filter((tag: any) => tag.id !== currentTag.id);
      const input = document.getElementById(
        currentTag.id
      ) as HTMLInputElement;
      input.checked = false;
      this.$store.dispatch("setTags", tags);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
});
